import { useQuery } from '@tanstack/react-query';
import api from '@/services/api';

// ── Types ────────────────────────────────────────────────────────────────────

export interface ScheduleEntry {
  year: 2025 | 2028 | 2034;
  dpe: 'G' | 'F' | 'E';
  units: number;
}

export interface Sector {
  rank: number;
  sector: string;
  priority: number;
  passoires: number;
  precarity: number;
  gain_gwh: number;
}

export interface RenovationData {
  passoires_count: number;
  passoires_pct: number;
  precarity_households: number;
  potential_gwh: number;
  co2_avoided_t: number;
  pace_per_year: number;
  schedule: ScheduleEntry[];
  sectors: Sector[];
}

// ── Hook ─────────────────────────────────────────────────────────────────────

/**
 * Fetches the renovation decision-support data for a given commune (INSEE code).
 * GET /territories/{insee}/renovation
 */
export function useRenovation(insee: string | null) {
  return useQuery<RenovationData>({
    queryKey: ['renovation', insee],
    queryFn: async () => {
      const { data } = await api.get<RenovationData>(`/territories/${insee}/renovation`);
      return data;
    },
    enabled: !!insee,
  });
}
